import { Card } from "@/components/ui/card";
import { useMemo } from "react";

interface NumberFrequencyProps {
  frequencies: Record<number, number>;
}

export const NumberFrequency = ({ frequencies }: NumberFrequencyProps) => {
  const sortedFrequencies = useMemo(() => {
    return Object.entries(frequencies)
      .map(([num, count]) => ({ number: parseInt(num), count }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 20);
  }, [frequencies]);

  const maxCount = sortedFrequencies[0]?.count || 1;

  return (
    <Card className="p-6">
      <h3 className="text-xl font-bold text-foreground mb-4">Most Generated Numbers (Top 20)</h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 gap-3">
        {sortedFrequencies.map(({ number, count }) => {
          const intensity = (count / maxCount) * 100;
          return (
            <div
              key={number}
              className="relative p-4 rounded-lg border border-border text-center transition-all hover:scale-105"
              style={{
                backgroundColor: `hsl(var(--primary) / ${intensity * 0.3}%)`,
              }}
            >
              <div className="text-2xl font-bold text-foreground">{number}</div>
              <div className="text-xs text-muted-foreground mt-1">{count}x</div>
            </div>
          );
        })}
      </div>
      {sortedFrequencies.length === 0 && (
        <p className="text-sm text-muted-foreground text-center py-8">No data available yet</p>
      )}
    </Card>
  );
};
